import React, { useState, useContext, useEffect } from "react";
import { TextField, Button, Box, Typography, Alert } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthContext from "../auth/AuthContext";

const Login = () => {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [searchParams] = useSearchParams();
  
  const navigate = useNavigate();

  // Check for session expiration message
  useEffect(() => {
    if (searchParams.get('session_expired') === 'true') {
      setError("Your session has expired. Please log in again.");
    }
  }, [searchParams]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      await login(username, password);
      navigate("/gardens"); // Redirect after successful login
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <Box sx={{ 
      width: { xs: '100%', sm: 400 }, 
      maxWidth: '100%',
      margin: "0 auto", 
      padding: { xs: 2, sm: 2 },
      boxSizing: 'border-box'
    }}>
      <Typography variant="h4" gutterBottom align="center" sx={{ fontSize: { xs: '1.75rem', sm: '2.125rem' } }}>
        Agritur
      </Typography>
      <Typography variant="h5" gutterBottom align="center" sx={{ fontSize: { xs: '1.5rem', sm: '1.75rem' } }}>
        Login
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
      
      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          {success}
        </Alert>
      )}
      
      <form onSubmit={handleLogin}>
          <TextField
            fullWidth
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            margin="normal"
            required
            sx={{
              '& .MuiInputBase-root': {
                fontSize: { xs: '1rem', sm: '1rem' }
              }
            }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            required
            sx={{
              '& .MuiInputBase-root': {
                fontSize: { xs: '1rem', sm: '1rem' }
              }
            }}
          />
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2, py: { xs: 1.25, sm: 1 } }}>
            Login
          </Button>
        </form>
    </Box>
  );
};

export default Login;
